import { useCallback } from 'react';

import { trackEvent } from '../../../../helpers/analytics';

export const useIntroRequest = ({ sharedView, viewId, list, activeNetwork, user, updateView }) => {
  const onIntroRequestManagerChange = useCallback(
    async (manager) => {
      if (!viewId || !manager) return;

      try {
        await updateView({
          sharedListId: list.id,
          id: viewId,
          data: {
            introRequestManagerId: manager.id,
            introRequestManager: manager,
          },
        });
      } catch (error) {
        // Error already handled by updateViewWithToast
      }
    },
    [viewId, list.id, updateView],
  );

  const onShowIntroRequestChange = useCallback(
    async (changedValue) => {
      if (!viewId) return;

      try {
        await updateView({
          sharedListId: list.id,
          id: viewId,
          data: {
            introRequestsEnabled: changedValue,
            introRequestManagerId: sharedView?.introRequestManager?.id ?? user.id,
          },
        });

        trackEvent('intro_requests_enabled', {
          collection_id: activeNetwork.id,
          list_id: list.id,
          action: changedValue ? 'enable' : 'disable',
        });
      } catch (error) {
        // Error already handled by updateViewWithToast
      }
    },
    [viewId, list.id, activeNetwork.id, user.id, sharedView?.introRequestManager?.id, updateView],
  );

  return {
    onIntroRequestManagerChange,
    onShowIntroRequestChange,
  };
};
